import { MAX_SUBJECT_AREA_NAME_LENGTH } from '@/constants/neon-constants';
import {
  SUBJECT_AREA_NAME_REGEX,
  SUBJECT_AREA_NAME_REGEX_ERROR_TEXT,
  SUBJECT_AREA_NAME_REGEX_MODIFIERS,
} from '@/constants/subject-area-constants';
import type { ValidationResult } from '@ps-refarch-ux/neon';
export type NeonFontWeightToken = 'normal' | 'medium' | 'bold';
export type NeonFontSizeToken = `font-size-${number}`;
export type NeonLineHeightToken = `line-height-${number}`;

interface NeonFontStyle {
  font: string;
  fontWeight: string;
}

export function createNeonFontStyle(level: number, weight: NeonFontWeightToken): NeonFontStyle {
  level = Number.isInteger(level) && level === level % 10 && level < 9 ? level : 0;
  return {
    font: `var(--__neon__font-${level})`,
    fontWeight: `var(--__neon__font-weight-${weight})`,
  };
}

export const neonVar = (name: string, fallback: string | number): string =>
  `var(--__neon__${name}, ${fallback})`;

export const neonFontWeightVar = (token: NeonFontWeightToken, fallback: number): string =>
  neonVar(`font-weight-${token}`, fallback);

export const neonFontSizeVar = (token: NeonFontSizeToken, fallback: string): string =>
  neonVar(token, fallback);

export const neonLineHeightVar = (token: NeonLineHeightToken, fallback: string): string =>
  neonVar(token, fallback);
const subjectAreaNameRegex = new RegExp(SUBJECT_AREA_NAME_REGEX, SUBJECT_AREA_NAME_REGEX_MODIFIERS);

export const validateSubjectAreaName = (
  value: string | undefined,
  duplicateErrorMessage?: string
): ValidationResult => {
  const input = value || '';
  if (!input.trim()) {
    return {
      isValid: false,
      errorMessage: 'This field is required.',
    };
  }
  if (input.length > MAX_SUBJECT_AREA_NAME_LENGTH) {
    return {
      isValid: false,
      errorMessage: `The name cannot contain more than ${MAX_SUBJECT_AREA_NAME_LENGTH} characters.`,
    };
  }
  if (!subjectAreaNameRegex.test(input)) {
    return {
      isValid: false,
      errorMessage: SUBJECT_AREA_NAME_REGEX_ERROR_TEXT,
    };
  }

  if (duplicateErrorMessage) {
    return {
      isValid: false,
      errorMessage: duplicateErrorMessage,
    };
  }

  return {
    isValid: true,
  };
};
